import { makeStyles } from "tss-react/mui";
import { OrderStatus, WorkOrderStatus } from "@miplatform/types";
import { Box, Typography } from "@mui/material";
import { OrderStatusDisplayChip } from "../OrderStatusDisplayChip/OrderStatusDisplayChip";
import { WorkOrderStatusDisplayChip } from "../WorkOrderStatusDisplayChip/WorkOrderStatusDisplayChip";

export function EntityStatusListItemView<EntityType>(
  props: EntityStatusListItemViewProps<EntityType>
) {
  const {
    entity,
    getDisplayName,
    getDetail,
    onEntityClick,
    getStatus,
    isWorkOrder,
  } = props;

  const { classes } = useStyles();
  return (
    <Box
      className={classes.entityStatusListItem}
      onClick={(event) => onEntityClick?.(event, entity)}
    >
      <Box className={classes.detailsContainer}>
        <Typography variant="HD2">{getDisplayName(entity)}</Typography>
        <Typography variant="caption">{getDetail(entity)}</Typography>
      </Box>
      {isWorkOrder && (
        <WorkOrderStatusDisplayChip
          status={getStatus(entity) as WorkOrderStatus}
        />
      )}
      {!isWorkOrder && (
        <OrderStatusDisplayChip status={getStatus(entity) as OrderStatus} />
      )}
    </Box>
  );
}

interface EntityStatusListItemViewProps<EntityType> {
  entity: EntityType;
  getDisplayName: (entity: EntityType) => string;
  getDetail: (entity: EntityType) => string;
  onEntityClick?: (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    entity: EntityType
  ) => void;
  getStatus: (entity: EntityType) => string;
  isWorkOrder?: boolean;
}

const useStyles = makeStyles()((theme) => ({
  entityStatusListItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(1),
    backgroundColor: theme.palette.grey.mediumLight,
    borderRadius: theme.spacing(1),
    border: `1px solid ${theme.palette.grey.accent}`,
    cursor: "pointer",
  },
  detailsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(0.5),
  },
}));
